import { gql, useMutation } from '@apollo/client';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';

const SET_SORT_ORDER_FOR_SUGGESTED = gql`
  mutation SetSortOrderForSuggestedForSyndicate($syndicateId: ID!, $sortOrder: Int) {
    setSortOrderForSuggestedForSyndicate(syndicateId: $syndicateId, sortOrder: $sortOrder) {
      id
      sortOrderForSuggested
    }
  }
`;

interface SortOrderInputProps {
  syndicateId: string;
  sortOrder?: number | null;
}

const UpdateSortOrderForSuggested = ({ syndicateId, sortOrder }: SortOrderInputProps) => {
  const [setSortOrderMutation, { loading, error }] = useMutation(SET_SORT_ORDER_FOR_SUGGESTED);

  return (
    <FormPanelWithReadMode
      loading={loading}
      error={error}
      onSubmit={data => {
        setSortOrderMutation({
          variables: {
            syndicateId,
            sortOrder: data.sortOrder ? data.sortOrder : undefined,
          },
        });
      }}
      title="'Explore Syndicates' page (for approved users)"
    >
      <FormInput
        type="number"
        fieldName="sortOrder"
        label="'Explore Syndicates' page (for approved users)"
        defaultValue={sortOrder}
      />
    </FormPanelWithReadMode>
  );
};

export default UpdateSortOrderForSuggested;
